export default "__VITE_ASSET__D$USmpdU__"